module.exports = __webpack_public_path__ + "img/logo.19bc27d8.png";